export const PRODUCT_PROCESS_TYPE_SORT = 'sort'
export const PRODUCT_PROCESS_TYPE_RETURN = 'return'
